<template>
  <v-col cols="12" :sm="collapsedFilters ? 12 : 'auto'">
    <v-btn
      :text="$t('generic.clear')"
      :disabled="disabled"
      variant="outlined"
      color="secondary"
      :data-cc="clearBtnDataCc"
      @click="$emit('clear')"
    />
  </v-col>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  disabled: boolean;
  tableId?: string;
  collapsedFilters?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  collapsedFilters: false
});

const clearBtnDataCc = computed(() => {
  const prefix = 'clear-filters-btn';
  if (!props.tableId) return prefix;
  return `${prefix}-${props.tableId}`;
});
</script>
